// extracted by mini-css-extract-plugin
export default {"root":"fYSpfNTkDqaoHIzB5t9i","frame":"S9Y_Ntu8USdQRB7Zr9gg","placeHolderShimmer":"wOCQriRRCTKZUnJgD5W5"};